import { ReactElement, useState } from 'react';
import styles from '@/styles/components/no-connected-wallet.module.less';
import Wallet from '@/components/wallet';
import { Button } from 'antd';
import { useWallet } from '@/services';
import { useConnectWallet } from '@web3-onboard/react';
interface CheckLoginProps {
    children?: ReactElement | ReactElement[];
}
const CheckLogin = ({ children }: CheckLoginProps): ReactElement => {
    const [visible, setVisible] = useState(false);
    const { logged } = useWallet();
    const [, connect] = useConnectWallet();
    if (logged) {
        return children ? <>{children}</> : <></>;
    }
    return (
        <div className={styles['admin-no-connected-wallet']}>
            <Wallet visible={visible} hide={() => setVisible(false)}>
                {<WalletUnconnected toLink={() => connect()} />}
            </Wallet>
        </div>
    );
};

const WalletUnconnected = ({ toLink }: { toLink: () => void }): ReactElement => {
    return (
        <div className={styles['login']}>
            <Button className={styles['connect-wallet']} onClick={toLink}>
                Connect Wallet
            </Button>
        </div>
    );
};

export default CheckLogin;
